import {FC, useContext} from 'react';
import {capitalizeFirstLetter} from '~/common/utils';
import {Drawer} from '~/QuickEcards/components/Drawer/Drawer';
import {
  AssetGridProps,
  OptionsContents,
} from '~/QuickEcards/components/OptionsContents/OptionsContents';
import {OptionsPanel} from '~/QuickEcards/components/OptionsPanel/OptionsPanel';
import {BottomSheetTabContext} from '~/QuickEcards/context/BottomSheetTabContext';
import {Tab} from '~/QuickEcards/types/misc';

interface OptionsBottomDrawerProps extends AssetGridProps {
  tab: Tab | null;
}

export const OptionsBottomDrawer: FC<OptionsBottomDrawerProps> = ({tab, assets, onAssetClick}) => {
  const {snap, setSnap, open, setOpen} = useContext(BottomSheetTabContext);

  return (
    <Drawer
      snapValue={snap}
      updateSnapValue={setSnap}
      isOpen={open}
      toggleOpen={setOpen}
      trigger={<OptionsPanel />}
      title={capitalizeFirstLetter(tab ?? '')}
      hiddenTitle
      content={<OptionsContents assets={assets} onAssetClick={onAssetClick} />}
    />
  );
};
